import { EnvName } from '../utils/api';

type Toggle = boolean | 'always';

export type IEnv = Record<EnvName, Toggle>;

export enum ExperimentId {
	PASSWORDS = 'passwords',
	OIDC = 'oidc'
}

export interface IExperiment {
	id: ExperimentId;
	env: Partial<IEnv>;
}

export const EXPERIMENT_PREFIX = 'experiment';

export const EXPERIMENTS_SESSION_KEY = 'experiments';
